<script setup>
defineEmits('navbarOpen')
</script>
<template>
  <button
    data-collapse-toggle="navbar-sticky"
    data-test-id="hamburger-menu-button"
    type="button"
    class="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-stone-700 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200"
    aria-controls="navbar-sticky"
    aria-expanded="false"
    @click="$emit('navbarOpen')"
  >
    <span class="sr-only">Open main menu</span>
    <svg
      class="w-5 h-5"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 17 14"
    >
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.67"
        d="M1 1h15M1 7h15M1 13h15"
      />
    </svg>
  </button>
</template>
